import { extractMethodFromQueryKey } from "../../../keys";
import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

/**
 * `bulk_update` marks every one of the user's notifications read, or deletes them all. It takes no
 * filter and returns `{}`, so there is no response payload to patch caches with — matching queries
 * are invalidated instead.
 *
 * The `getSome` entry deliberately matches the count query (`getSome-count`) as well as the list
 * itself: the unread badge is a separate count query, and a bulk action changes what it should
 * report. `exact: false` plus a predicate on the method segment is what reaches both keys, since
 * `getSome` is not a prefix of `getSome-count`.
 *
 * The delay exists because the server applies this write fire-and-forget and returns 204
 * immediately — an instant refetch can still read the pre-update rows.
 */
export const USER_NOTIFICATIONS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"user_notifications"> =
  {
    bulk_update: () => ({
      getSome: {
        exact: false,
        delay: 1000,
        predicate: ({ queryKey }) => {
          const method = extractMethodFromQueryKey(queryKey);
          return method === "getSome" || method === "getSome-count";
        },
      },
    }),
  };
